import { gql } from "@apollo/client";

export const UPDATE_OVERVIEW = gql`
  mutation updateOverview(
    $templateId: String
    $clientIdentifier: String
    $input: TemplateOverviewInput!
  ) {
    invoiceInterpretation {
      updateOverview(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        input: $input
      ) {
        success
      }
    }
  }
`;
